export interface SurveyResponseError {
    error: string;
    file?: string;
    message?: string;
}

export function isSurveyResponseError(r: any): r is SurveyResponseError {
    return "error" in r;
}
